import { createReducer } from '@reduxjs/toolkit';
import set from 'lodash/set';

import {
  initializeExpansionStateOfAllBusinessesAndProducts,
  setupCFAndCCPLinks,
  setupCFLinks,
  toggleAllCampaignLinesExpansion,
  toggleCampaignLineExpansion,
  toggleCreativesVisibility,
  toggleDelayReasonVisibility,
  togglePushInProgress,
} from '../actions';

export default createReducer(
  {
    isDelayReasonVisible: false,
    areCreativesVisible: true,
    pushInProgress: false,
    expansionStateByLabel: {},
    downstreamSystemLinks: {
      creative_factory: '',
      ccp: '',
    },
  },
  /* eslint-disable no-param-reassign */
  {
    [toggleDelayReasonVisibility]: (
      state,
      { payload: { isDelayReasonVisible } },
    ) => {
      set(state, 'isDelayReasonVisible', isDelayReasonVisible);
    },
    [toggleCreativesVisibility]: (
      state,
      { payload: { areCreativesVisible } },
    ) => {
      set(state, 'areCreativesVisible', areCreativesVisible);
    },
    [togglePushInProgress]: (state, { payload: { status } }) => {
      state.pushInProgress = status;
    },
    [initializeExpansionStateOfAllBusinessesAndProducts]: (
      state,
      { payload: { campaignLines } },
    ) => {
      const expansionStateByLabel = {};
      campaignLines.forEach(businessLine => {
        expansionStateByLabel[businessLine.label] = false;
        businessLine.products.forEach(productLine => {
          expansionStateByLabel[productLine.label] = false;
        });
      });
      state.expansionStateByLabel = expansionStateByLabel;
    },
    [toggleCampaignLineExpansion]: (
      state,
      { payload: { label, expanded } },
    ) => {
      state.expansionStateByLabel[label] = expanded;
    },
    [toggleAllCampaignLinesExpansion]: (state, { payload: { expanded } }) => {
      Object.keys(state.expansionStateByLabel).forEach(key => {
        state.expansionStateByLabel[key] = expanded;
      });
    },
    [`${setupCFLinks}-success`]: (state, { payload }) => {
      state.downstreamSystemLinks = {
        ...state.downstreamSystemLinks,
        ...payload,
      };
    },
    [`${setupCFAndCCPLinks}-success`]: (state, { payload }) => {
      state.downstreamSystemLinks = {
        ...state.downstreamSystemLinks,
        ...payload,
      };
    },
  },
  /* eslint-enable no-param-reassign */
);
